module.exports = __webpack_public_path__ + "img/homevisit_04.f38a4584.svg";